<template>
  <transition name="slide-fade">
    <div id="create-menu">
      <div class="row">
        <div class="col-sm-9">
          <input type="text" class="cool-input" placeholder="spotify link" v-model="spotifyLink"/>
        </div>
        <div class="col-sm-3">
          <a href="#" class="action-button shadow animate green" @click="addSong">+</a>
        </div>
        <div class="col-sm-12">
          <song-list :songs="songs"/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  getCurrentUser,
  createPlaylist,
  setToken,
  getSong,
  addSongToPlaylist,
  initPlaylistStream,
  deactiveShuffleMode
} from '../utils/spotify-driver'
import SongList from './SongList'

export default {
  components: {SongList},
  name: 'playlist',
  props: ['accessToken', 'name'],
  data () {
    return {
      spotifyLink: '',
      songs: [],
      userId: '',
      playlistId: '',
      playlist: {}
    }
  },
  mounted () {
    setToken(this.accessToken)
    if (this.playlistId !== '') {
      return
    }
    getCurrentUser()
      .then((response) => {
        this.userId = response.data.id
        return createPlaylist(this.userId, this.name)
      })
      .then((response) => {
        this.playlist = response.data
      })
  },
  methods: {
    addSong () {
      if (this.spotifyLink === '') {
        return
      }
      let songId = this.spotifyLink.slice(31, 53)
      this.spotifyLink = ''
      let songToAdd
      getSong(songId)
        .then((response) => {
          songToAdd = response.data
          return addSongToPlaylist(this.userId, this.playlist.id, songToAdd.uri)
        })
        .then(() => {
          this.songs.push(songToAdd)
          if (this.songs.length === 1) {
            initPlaylistStream(this.playlist.uri)
          }
        })
    }
  }
}
</script>

<style type="scss" scoped>
  @import url('https://fonts.googleapis.com/css?family=Pacifico');
  @import url('https://fonts.googleapis.com/css?family=Montserrat|Rammetto+One');

  h1 {
    color: aliceblue;
  }

  .animate {
    transition: all 0.1s;
    -webkit-transition: all 0.1s;
  }

  .action-button{
    padding: 5px 15px;
    margin: 30px 30px 0 0;
    float: left;
    border-radius: 10px;
    font-family: 'Montserrat', sans-serif;
    font-size: 25px;
    color: aliceblue;
    text-decoration: none;
  }

  .green {
    background-color: #82BF56;
    border-bottom: 5px solid #669644;
    text-shadow: 0px -2px #669644;
  }

  .action-button:active {
    transform: translate(0px, 5px);
    -webkit-transform: translate(0px, 5px);
    border-bottom: 1px solid;
    animation: bounce-in 1s;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .cool-input {
    color: aliceblue;
    font-family: 'Montserrat', sans-serif;
    font-size: 2em;
    text-align: center;
    margin: 0 auto;
    margin-bottom: .2em;
    margin-top: 25px;
    background-color: transparent;
    width: 90%;
    padding: 0;
    border: none;
    border-bottom: solid 5px #82BF56;
    &:focus {
      outline: none;
    }
  }
  input:focus{
    outline: none;
  }
  input:focus::-webkit-input-placeholder {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Playlist.vue